import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { MenuItem } from '../../../models';
import { MenuService, TranslationService } from '../../../services';
import { AuthService } from '../../../../auth';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.scss',
})
export class MobileMenuComponent extends BaseComponent implements OnInit {
  isAuthenticated$: Observable<boolean>;
  menuItems$: Observable<MenuItem[]>;

  constructor(
    public translationService: TranslationService,
    private menuService: MenuService,
    private authService: AuthService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    this.menuItems$ = this.menuService.menuItems(this.router.url);
  }
}
